export default __webpack_public_path__ + "static/leaf 2-a9095ea2f36e833ecc40de883af40d94.png";